import { Routes, Route } from "react-router-dom";
import NavigateProvider from "../src/contentnavigateprovider/navigationProvider"
import './App.css';
import "./userheadernav.css";
import "./usersidenav.css";
import ScrollToTop from "./ScrollToTop";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import ImageUpload from "./Component/userdashboard/imageUpload";


import "bootstrap/dist/css/bootstrap.min.css";
import Home from './Component/Home';
import Register from './Component/register';
import Login from './Component/Login';
import OtpVerify from './Component/Verifyotp';
import Profile from "./Component/profiles";
import Contact from "./Component/contact";
import About from "./Component/aboutus";
import Membership from "./Component/membership";
import Privacy from "./Component/privacy";
import ReportAbuse from "./Component/reportAbuse";
import HowItWorks from "./Component/howItWorks";
import Terms from "./Component/terms";
import FAQ from "./Component/faq";

import PublicRoutes from "./Component/PublicRoutes";
import ProtectedRoutes from "./Component/ProtectedRoutes";


// User 
import Userdashboardlayout from "./Component/userdashboard/userdashboardlayout";
import UserDashboard from "./Component/userdashboard/dashboard";
import ProfileSearch from './Component/userdashboard/searchProfile';
import ProfileDetails from "./Component/userdashboard/profileDetails";
import UserMembership from "./Component/userdashboard/userMembership";
import Editprofile from "./Component/userdashboard/editprofile";
import Recommendations from "./Component/userdashboard/recommendations";
import Interests from "./Component/userdashboard/interests";
import Messages from "./Component/userdashboard/mesage";
import Shortlist from "./Component/userdashboard/shortlist";
import PartnerPreference from "./Component/userdashboard/partnerPreference";
import SentInterests from "./Component/userdashboard/sentInterest";
import VerifyAadhaar from "./Component/userdashboard/verifyAadhaar";

// payment 
import Checkout from "./Component/userdashboard/checkout";
import PlatformUsage from "./Component/platform-usage";
import PaymentPolicy from "./Component/paymentPolicy";
import Compliance from "./Component/compliance";

// chatbot
import FloatingChatBot from "./Component/userdashboard/chatbot";
import BotProfileSearch from "./Component/userdashboard/botprofileSearch";
import AccountSettings from "./Component/userdashboard/accountsettngs";
import MyPlan from "./Component/userdashboard/myplan";




function App() {
  return (
    <NavigateProvider>
      <ScrollToTop />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar
        closeButton={false}
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
      />

      <Routes>

        <Route path="/about-us" element={<About />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/report-abuse" element={<ReportAbuse />} />
        <Route path="/how-it-works" element={<HowItWorks />} />
        <Route element={<PublicRoutes />}>
          <Route path="/" element={<Home />} />
          <Route path="/register" element={<Register />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/login" element={<Login />} />
          <Route path="/otpverify" element={<OtpVerify />} />

          <Route path="/membership" element={<Membership />} />
          <Route path="/search-profile" element={<Profile />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/report-abuse" element={<ReportAbuse />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/platform-usage" element={<PlatformUsage />} />
          <Route path="/payment-policy" element={<PaymentPolicy />} />
          <Route path="/compliance" element={<Compliance />} />
        </Route>

        <Route element={<ProtectedRoutes />}>
          <Route path="/user" element={<Userdashboardlayout />}>
            <Route path="home" element={<UserDashboard />} />
            <Route path="profile-search" element={<ProfileSearch />} />
            <Route path="profile-details/:id" element={<ProfileDetails />} />
            <Route path="membership" element={<UserMembership />} />
            <Route path="edit-profile" element={<Editprofile />} />
            <Route path="recommendations" element={<Recommendations />} />
            <Route path="interests" element={<Interests />} />
            <Route path="shortlist" element={<Shortlist />} />
            <Route path="partner-preference" element={<PartnerPreference />} />
            <Route path="message" element={<Messages />} />
            <Route path="galleryupload" element={<ImageUpload />} />
            <Route path="checkout" element={<Checkout />} />
            <Route path="sent-requests" element={<SentInterests />} />
            <Route path="verify-aadhaar" element={<VerifyAadhaar />} />
            <Route path="search-profile" element={<BotProfileSearch />} />
            <Route path="account-settings" element={<AccountSettings />} />
            <Route path="my-plans" element={<MyPlan />} />


          </Route>
        </Route>

      </Routes>
      <FloatingChatBot />
    </NavigateProvider>
  );
}

export default App;
